import { YFC } from '@/utils/constants';
import { ConfManager } from 'yellowfin-ui-lib';

const confManager = ConfManager.getInstance();
confManager.userCookie = YFC.USER_COOKIE;
confManager.tokenCookie = YFC.TOKEN_COOKIE;
confManager.i18nCookie = YFC.I18N_COOKIE;
confManager.userPath = 'customer';
confManager.loginPath = 'access/customer/login';
confManager.apiI18n = true;
confManager.useCookie = true;

confManager.globalHeaders = [
	{ key: 'x-yf-domain', value: 'https://www.leadersalotti.com' }
]
